import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { NgForm } from '@angular/forms';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { CentrosDeTrabajoService } from '../_services/centrosdetrabajo.service';
import { EmpresasService } from '../_services/empresas.service';

import { CentroDeTrabajo } from '../_models/centrodetrabajo.model';

import { AppSettings } from '../_models/settings.models'


declare var jQuery: any;

@Component({
    selector: 'centrodetrabajo',
    templateUrl: 'centrodetrabajo.template.html'
})
export class CentroDeTrabajoComponent implements OnInit, OnDestroy, AfterViewInit {

  subscription: Subscription;

  centrodetrabajo: CentroDeTrabajo;
  insertonuevo: boolean = false;

  iconocerrar: string = 'fa fa-times';

  apikeytoken: string = AppSettings.API_KEYTOKEN;
  currentUserToken: string = localStorage.getItem('currentUserToken');

  listaempresas: any = [];
  listaprovincias: any = [];
  listamunicipios: any = [];
  listacnae: any = [];
  listasubcnae: any = [];
  listaactividadesempresariales: any = [];
  listainterlocutoresinicie: any = [];

  id_zona_seleccionada: number = 0;
  id_area_seleccionada: number = 0;
  id_subarea_seleccionada: number = 0;

  listazonas: any = [];
  listaareas: any = [];
  listasubareas: any = [];

  tipocentros: any = [];

  area: string = "";
  zona: string = "";
  subarea: string = "";

  nuevaarea: string = "";
  nuevazona: string = "";
  nuevasubarea: string = "";

  editararea: boolean = false;
  editarzona: boolean = false;
  editarsubarea: boolean = false;

  @ViewChild('formreport') public formreport:ElementRef;

  constructor(private seguridad: SeguridadService,
      private router: Router,
      private normasService: NormasService,
      private centrosDeTrabajoService: CentrosDeTrabajoService,
      private empresasService: EmpresasService,
      private globalEventsManager: GlobalEventsManager,
      private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {

    this.centrodetrabajo = new CentroDeTrabajo();

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
        if (mode !== null) {
            if (!mode) {
                this.router.navigate(['login']);
            }
        }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path':'/centrosdetrabajo',
        'name': 'Administración de centros de trabajo'
      },
      {
        'path':'#',
        'name': 'Centro'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    let _id_ct = this.activatedRoute.snapshot.params["id_ct"];
    if (_id_ct && _id_ct != 0 && _id_ct != 'nuevo' ){
      this.getCentroDeTrabajo(_id_ct);
    }else{
      this.nuevoCentro();
    }


    this.getListaEmpresas();
    this.getListaInterlocutoresInicie();


  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  nuevoCentro(){
    this.insertonuevo = true;
    this.centrodetrabajo.denominacion = "Nuevo Centro de Trabajo";
    this.getListaProvincias();
    this.getListaActividadesEmpresariales();
  }

  getCentroDeTrabajo(id_ct: number){

    this.centrosDeTrabajoService.getCentroDeTrabajo(id_ct).subscribe(
        data => {
          if (data){
            this.updateCentroDeTrabajo(data.json().centrodetrabajo);
          }
        }
    );
  }

  updateCentroDeTrabajo(data){

    console.log(data);

    this.centrodetrabajo.codpostal =data.codpostal;
    this.centrodetrabajo.direccion = data.direccion;
    this.centrodetrabajo.email = data.email;
    this.centrodetrabajo.id_actividadempresarial =data.id_actividad;
    this.centrodetrabajo.id_cnae =data.id_cnae;
    this.centrodetrabajo.id_empresa =data.id_empresa;
    this.centrodetrabajo.id_interlocutorinicie =data.id_interlocutorinicie;
    this.centrodetrabajo.id_municipio =data.id_municipio;
    this.centrodetrabajo.id_provincia =data.id_provincia;
    this.centrodetrabajo.id_subcnae =data.id_subcnae;
    this.centrodetrabajo.denominacion = data.denominacion;
    this.centrodetrabajo.responsable = data.responsable;
    this.centrodetrabajo.responsabledni = data.responsabledni;
    this.centrodetrabajo.id_ct = data.id_ct;
    this.centrodetrabajo.telefono = data.telefono;
    this.centrodetrabajo.logo = "";
    this.centrodetrabajo.foto = "";
    this.centrodetrabajo.interlocutor = data.interlocutor;
    this.centrodetrabajo.interlocutoremail = data.interlocutoremail;
    this.centrodetrabajo.interlocutortelefono = data.interlocutortelefono;
    this.centrodetrabajo.id_area = data.id_area;
    this.centrodetrabajo.id_subarea = data.id_subarea;
    this.centrodetrabajo.id_zona = data.id_zona;
    this.centrodetrabajo.id_tipo = data.id_tipo;

    this.getListaProvincias();
    this.getListaMunicipios(this.centrodetrabajo.id_provincia);

    this.getListaActividadesEmpresariales();
    this.getListaCnae(this.centrodetrabajo.id_actividadempresarial);
    this.getListaSubCnae(this.centrodetrabajo.id_cnae);

    this.getListaZonas(this.centrodetrabajo.id_empresa);

    if (this.centrodetrabajo.id_area || this.centrodetrabajo.id_zona || this.centrodetrabajo.id_subarea){
      this.getZona(this.centrodetrabajo.id_ct);
    }


    this.getListaTipoCentros();

  }

  getListaTipoCentros(){
    console.log("voy a recuperar los tipos de centros");

    this.empresasService.getListaTipoCentros().subscribe(
      data => {
        console.log(data.json().lista);
        this.tipocentros = data.json().lista;
      }
    );
  }

  getListaZonas(id_empresa: number){

    let params = {
      id_empresa: id_empresa,
      action: "listagetZonas"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listazonas = data.json().lista;
          }
        }
    );

  }

  getListaAreas(id_zona: number){
    let params = {
      id_zona: id_zona,
      action: "listagetZonasAreas"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaareas = data.json().lista;
          }
        }
    );
  }

  getListaSubareas(id_area: number){
    let params = {
      id_area: id_area,
      action: "listagetZonasAreasSubareas"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listasubareas = data.json().lista;
          }
        }
    );
  }

  getArea(id_area: number){

    this.empresasService.getArea(id_area).subscribe(
        data => {
          if (data){
            let aux = data.json().area;
            console.log(aux);
            this.area = aux[0].descripcion;
            this.zona = aux[0].zona;
          }
        }
    );
  }

  getSubarea(id_subarea: number){

    this.empresasService.getSubarea(id_subarea).subscribe(
        data => {
          if (data){
            let aux = data.json().area;
            console.log(aux);
            this.subarea = aux[0].descripcion;
            this.area = aux[0].area;
            this.zona = aux[0].zona;
          }
        }
    );
  }

  getZona(id_ct: number){

    this.empresasService.getZona(id_ct).subscribe(
        data => {
          if (data){
            let aux = data.json().zona;
            console.log(aux);
            this.subarea = aux[0].subarea;
            this.area = aux[0].area;
            this.zona = aux[0].zona;
          }
        }
    );
  }

  getListaEmpresas(){

    this.empresasService.getListaEmpresas().subscribe(
        data => {
          if (data){

            this.listaempresas = data.json().lista;
            console.log(this.listaempresas);
          }
        }
    );

  }

  getListaProvincias(){

    let params = {
      action: "ListagetProvincias"
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
          }
        }
    );

  }

  getListaCnae(id_cnae: number){

    let params = {
      action: "ListagetCNAE",
      id_cnae: id_cnae
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacnae = data.json().lista;
          }
        }
    );

  }

  getListaSubCnae(id_cnae: number){

    let params = {
      action: "ListagetSUBCNAE",
      id_cnae: id_cnae
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listasubcnae = data.json().lista;
          }
        }
    );

  }

  getListaActividadesEmpresariales(){

    let params = {
      action: "ListagetActividadesEmpresariales"
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaactividadesempresariales = data.json().lista;
          }
        }
    );

  }

  getListaInterlocutoresInicie(){

    let params = {
      action: "ListagetInterlocutoresEmpresas"
    }

    this.centrosDeTrabajoService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listainterlocutoresinicie = data.json().lista;
          }
        }
    );

  }




  guardar(formulario: NgForm, event: Event){
    this.onSubmit(formulario,event);
  }

  onSubmit(formulario: NgForm, event: Event =null){
    event.preventDefault;

    let centrodetrabajo: any;

    centrodetrabajo = {
      codpostal: this.centrodetrabajo.codpostal,
      direccion : this.centrodetrabajo.direccion,
      email : this.centrodetrabajo.email,
      id_ct : this.centrodetrabajo.id_ct,
      id_actividad: this.centrodetrabajo.id_actividadempresarial,
      id_cnae: this.centrodetrabajo.id_cnae,
      id_empresa: this.centrodetrabajo.id_empresa,
      id_interlocutorinicie: this.centrodetrabajo.id_interlocutorinicie,
      id_municipio: this.centrodetrabajo.id_municipio,
      id_provincia: this.centrodetrabajo.id_provincia,
      id_subcnae: this.centrodetrabajo.id_subcnae,
      denominacion : this.centrodetrabajo.denominacion,
      responsable : this.centrodetrabajo.responsable,
      responsabledni : this.centrodetrabajo.responsabledni,
      telefono : this.centrodetrabajo.telefono,
      logo : this.centrodetrabajo.logo,
      foto : this.centrodetrabajo.foto,
      interlocutor : this.centrodetrabajo.interlocutor,
      interlocutoremail : this.centrodetrabajo.interlocutoremail,
      interlocutortelefono : this.centrodetrabajo.interlocutortelefono,
      id_tipo: this.centrodetrabajo.id_tipo
    };


    this.centrosDeTrabajoService.setCentroDeTrabajo(centrodetrabajo).subscribe(
      data => {
        if (data){

          let al: any = {
            "texto" : "Centro de trabajo guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateCentroDeTrabajo(data.json().centrodetrabajo);
          if (this.insertonuevo){
            this.router.navigate(['centrosdetrabajo',this.centrodetrabajo.id_ct]);
          }
        }
      }
    );
  }

  eliminarArea(id_area: number){
    this.empresasService.eliminarArea(this.centrodetrabajo.id_ct, id_area).subscribe(
        data => {
          if (data){
            let aux = data.json().area;
            this.area = "";
            this.zona = "";
            this.centrodetrabajo.id_area = 0;
          }
        }
    );
  }

  eliminarAsignacionZona(id_ct: number){
    this.empresasService.eliminarAsignacionZona(this.centrodetrabajo.id_ct).subscribe(
        data => {
          if (data){
            let aux = data.json().area;
            this.area = "";
            this.zona = "";
            this.subarea = "";
            this.centrodetrabajo.id_area = 0;
            this.centrodetrabajo.id_zona = 0;
            this.centrodetrabajo.id_subarea = 0;
          }
        }
    );
  }

  anadirArea(){
    if (this.id_area_seleccionada && this.id_area_seleccionada != 0){
      this.empresasService.anadirArea(this.centrodetrabajo.id_ct, this.id_area_seleccionada).subscribe(
          data => {
            if (data){
              this.getCentroDeTrabajo(this.centrodetrabajo.id_ct);
              this.id_area_seleccionada = 0;
            }
          }
      );
    }

  }

  nuevaArea(){
    if (this.id_zona_seleccionada != 0 && this.nuevaarea != '' ){
      this.empresasService.nuevaArea(this.centrodetrabajo.id_ct, this.id_zona_seleccionada, this.nuevaarea).subscribe(
          data => {
            if (data){
              this.getCentroDeTrabajo(this.centrodetrabajo.id_ct);
              this.id_area_seleccionada = 0;
              this.nuevaarea = "";
              this.editararea = false;
            }
          }
      );
    }

  }

  asignarZona(){
    
    this.empresasService.asignarZona(this.centrodetrabajo.id_ct, this.id_area_seleccionada, this.id_zona_seleccionada, this.id_subarea_seleccionada, this.nuevaarea, this.nuevazona, this.nuevasubarea).subscribe(
        data => {
          if (data){
            this.id_area_seleccionada = 0;
            this.id_subarea_seleccionada = 0;
            this.id_zona_seleccionada = 0;
            this.area = "";
            this.zona = "";
            this.subarea = "";
            this.nuevaarea = "";
            this.nuevazona = "";
            this.nuevasubarea = "";
            this.editararea = false;
            this.editarzona = false;
            this.editarsubarea = false;
            this.getCentroDeTrabajo(this.centrodetrabajo.id_ct);
          }
        }
    );
    
  }


}



// WEBPACK FOOTER //
// ./src/app/centrosdetrabajo/centrodetrabajo.component.ts